import * as Yup from "yup";

export const bankAccountSchema = Yup.object().shape({
    description: Yup.string()
        .min(2, "Descrição muito curta")
        .required("A descrição da conta é obrigatória"),
    bankName: Yup.string().required("O banco é obrigatório"),
    accountType: Yup.string().oneOf(["corrente", "poupanca", "investimento", "caixa"]).required("Tipo de conta é obrigatório"),
    agency: Yup.string().nullable(),
    accountNumber: Yup.string().nullable(),
    initialBalance: Yup.number().typeError("Deve ser um número").required("Saldo inicial é obrigatório"),
    status: Yup.string().oneOf(["active", "inactive"]).default("active"),
});
